import { type ReactNode } from 'react';

interface SectionHeadingProps {
  kicker: string;
  icon?: string;
  title: string;
  desc: string;
  action?: ReactNode;
}

export default function SectionHeading({ kicker, icon = 'ri-fire-line', title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-3xl">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className={icon}></i>
          </span>
          {kicker}
        </span>
        <h3 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-[28px]">
          {title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}